// 订单支付接口
import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
export default {
    // 生成订单
    generate(data) {
        return zwitCore.HTTP.postJsonData(
            BASE_URL + "/zw-order/order/nf/generate",
            data,
            false
        );
    },
    // 银联支付接口
    getPay(data) {
        return zwitCore.HTTP.get(
            BASE_URL + "/zw-pay/pay",
            data,
            false
        );
    },
    // 订单状态
    status(data) {
        return zwitCore.HTTP.get(
            BASE_URL + "/zw-order/order/nf/status",
            data,
            false
        );
    },
};